export const SUBSECTION_NO_CONTENT =
  "No results found in interviews visible to the hiring team; this topic may be covered elsewhere to avoid duplication in notes.";
